<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="20" :offset="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleForm"
                        label-width="80px"
                        class="demo-ruleForm"
                    >
                        <el-form-item label="分析组别" prop="locationCode">
                            <el-col :span="22">
                                <el-select
                                    v-model="value"
                                    filterable
                                    placeholder="试一试搜索:类型"
                                    @change="handleChange2"
                                    size="large"
                                    style="width : 350px"
                                >
                                    <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="日期" prop="date">
                            <el-date-picker
                                v-model="ruleForm.date"
                                type="daterange"
                                range-separator="至"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-value="defaultVal"
                            >
                            </el-date-picker>
                            <p class="tip"><span>*</span>{{ dateNullTip }}</p>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="submitForm('ruleForm')"
                                >确认</el-button
                            >
                            <el-button @click="cancel">返回</el-button>
                            <el-button
                                @click="downLoad2('销售摘要')"
                                type="success"
                                >下载表格</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" style="float:right;margin-bottom:20px;">
                    <el-input
                        placeholder="请输入店铺名称"
                        v-model="input5"
                        class="input-with-select"
                        clearable
                        prefix-icon="el-icon-search"
                    >
                    </el-input>
                </el-col>
                <el-col :span="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="加载中"
                        :data="
                            tableData.filter(
                                elem =>
                                    !input5 || elem.addr.includes(input5.trim())
                            )
                        "
                        style="width: 100%"
                        border
                        max-height="340"
                        show-summary
                        :summary-method="getSummaries"
                    >
                        <el-table-column
                            label="地区"
                            prop="area"
                            v-if="isLabelObj.isLocation"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="品牌"
                            prop="brand"
                            v-if="isLabelObj.isBrand"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="店铺"
                            prop="addr"
                            v-if="isLabelObj.isShop"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="类型"
                            prop="productName"
                            v-if="isLabelObj.isDescription"
                            align="left"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="订单数量"
                            prop="orderCount"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="销售数量"
                            prop="amount"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="销售金额"
                            prop="totalPrice"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            label="免费金额"
                            prop="freePrice"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less" scoped>
@import "~@/assets/css/common";
</style>
<script>
import requestMixin from '../../mixins/request'
import common from '../../mixins/common'
import axios from '../../env/axios'
import apis from '../../env/apis'
export default {
    mixins: [requestMixin, common],
    data () {
        return {
            ruleForm: {
                locationCode: '',
                date: ''
            },
            defaultVal: [],
            rules: {
                locationCode: [
                    { required: true, message: '请选择分析组别', trigger: 'blur' },
                ],
            },
            options2: [
                {
                    value: '1',
                    label: '类型'
                },
                {
                    value: '2',
                    label: '地区+类型'
                },
                {
                    value: '3',
                    label: '地区+品牌'
                },
                {
                    value: '4',
                    label: '地区+品牌+类型'
                },
                {
                    value: '5',
                    label: '地区+品牌+店铺+类型'
                }
            ],
            value: '',
            loading: false,
            tableData: [],
            labelTitle: '类型',
            isLabelObj: {
                isDescription: true,  //类型
                isLocation: true,  //地区
                isBrand: true,   //品牌齐
                isShop: true, //店铺
            },
            input5: ''
        }
    },
    mounted () {
        this.defaultNow();
    },
    methods: {
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { locationCode, date } = this.ruleForm;
                    let userId = sessionStorage.getItem('userId')
                    let params;
                    if (date) {
                        params = {
                            act: "saleSumary",
                            type: `${locationCode}`,
                            from: date[0],
                            to: date[1],
                            userId
                        }
                    } else {
                        params = {
                            act: "saleSumary",
                            type: `${locationCode}`,
                            from: '2020-01-01',
                            to: '2099-01-01',
                            userId
                        }
                    }
                    this.getReports(params);
                } else {
                    return false;
                }
            });
        },
        //点击取消，跳转到上一页
        cancel () {
            this.$router.go(-1)
        },
        //动态分类组别的act
        handleChange2 (value) {
            this.ruleForm.locationCode = value;
            if (value == '1') {
                this.isLabelObj = {
                    isDescription: true,
                    isLocation: false,
                    isBrand: false
                }
                this.tableData = [];
            } else if (value == '2') {
                this.isLabelObj = {
                    isDescription: true,
                    isLocation: true,
                    isBrand: false
                }
                this.tableData = [];
            } else if (value == '3') {
                this.isLabelObj = {
                    isDescription: false,
                    isLocation: true,
                    isBrand: true
                }
                this.tableData = [];
            } else if (value == '4') {
                this.isLabelObj = {
                    isDescription: true,
                    isLocation: true,
                    isBrand: true
                }
                this.tableData = [];
            } else if (value == '5') {
                this.isLabelObj = {
                    isDescription: true,
                    isLocation: true,
                    isBrand: true,
                    isShop: true
                }
                this.tableData = [];
            }
        },
        //请求结算报表
        getReports (params) {
            let that = this;
            that.loading = true;
             let userId = sessionStorage.getItem("userId") ;
            that.delType(params).then((res) => {
                let { code, data } = res.data;
                if (code == 200) {
                    this.loading = false;
                    let act = params.type;
                    if (act == '1' || act == '2' || act == '3' || act == '4' || act == '5') {
                        let params = {
                            act: 'findLocations',
                            userId
                        }
                        let params1 = {
                            act: 'findTypes',
                            userId
                        }
                        this.formalName(data, "locationCode", params)
                        this.formalName(data, "typeCode", params1)
                    }
                    data.forEach((v, i) => {
                        if (v.addr) {
                            v.addr = v.addr.split('-')[2]
                        }
                    })
                    // console.log(data) 
                    this.tableData = data;
                } else {
                    that.loading = false;
                    that.alert('查找失败!', 'warning')
                }
                // console.log(report)
                // if(status == true){
                //     let reportObj = report;
                //     this.loading = false;
                //     let act = params.act;
                //     if(act == 'summaryGroup1' || act == 'summaryGroup2' || act == 'summaryGroup3' || act == 'summaryGroup4' || act == 'summaryGroup6'){
                //         let params ={
                //             act : 'findLocations'
                //         }
                //         let params1 ={
                //             act : 'findTypes'
                //         }
                //         this.formalName(reportObj,"locationCode",params)
                //         this.formalName(reportObj,"typeCode",params1)
                //     }
                //     reportObj.forEach( (v,i) =>{
                //         if( v.locationName){
                //             v.locationName = v.locationName.split('-')[2]
                //         }
                //     })
                //     console.log(reportObj) 
                //     this.tableData = reportObj;
                // }else{
                //     this.loading = false;
                //     this.alert('查找失败!','warning')
                // }
            })
        },
        //券号类型改为券号名称
        formalName (arr, typeCode, params) {
            // console.log(arr)
            this.delType(params).then(res => {
                let { status, list } = res.data;
                var re = /(?=(?!\b)(\d{3})+$)/g
                if (status == true) {
                    list.forEach((elem => {
                        arr.forEach(elem1 => {
                            if (elem1.area == elem[typeCode].slice(0, 2)) {
                                elem1.area = elem.description.slice(0, 2)
                            }
                            if (elem1.brand == elem[typeCode].slice(2, 4)) {
                                elem1.brand = elem.description.split('-')[1]
                            }
                            // elem1.totalPrice = elem1.totalPrice.replace(re,',');
                        });
                    }))
                } else {
                    console.log(status)
                    // this.promptMsg('加载失败,请刷新重试！','info')
                }
            })
        },

        //总计最后一行
        getSummaries (param) {
            const { columns, data } = param;
            const columsLen = columns.length;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (columsLen == 5 && index === 1) {
                    sums[index] = '';
                    return;
                }
                if (columsLen == 6 && index === 2) {
                    sums[index] = '';
                    return;
                }
                if (columsLen == 7 && index === 3) {
                    sums[index] = '';
                    return;
                }
                if (columsLen == 8 && index === 4) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                // const values = data.map(item => Number(item[column.property].replace(/,/g, "")));
                // console.log(values)
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (columsLen == 5 && index === 2 || columsLen == 6 && index === 3 || columsLen == 7 && index === 4 || columsLen == 8 && index === 5) {
                        sums[index] = Number(sums[index]);
                    }else {
                        sums[index] = Number(sums[index]).toFixed(1)
                    }
                    // sums[index] = Number(sums[index]).toFixed(1);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        //下载表格
        downLoad2 (name) {
            this.isDownTable(this.tableData, this.downLoad, name);
        },
        defaultNow () {
            let defaultVal = this.defaultVal;
            defaultVal[0] = new Date();
            defaultVal[0] = defaultVal[0].getFullYear() + '-' + this.checkTime(defaultVal[0].getMonth() + 1) + '-' + this.checkTime(defaultVal[0].getDate());
            defaultVal[1] = defaultVal[0];
            this.ruleForm.date = defaultVal;
        }
    }
}
</script>
